import { buttonGroupClasses } from '@mui/material/ButtonGroup';
import { Components, Theme } from '@mui/material/styles';

import * as Shadows from 'src/theme/shadows';
import ColorUtils from 'src/utils/ColorUtils';

const MuiButtonGroup: Components<Theme>['MuiButtonGroup'] = {
  styleOverrides: {
    grouped: {
      minWidth: 'auto',
    },
    contained: {
      boxShadow: Shadows.PrimaryButtonShadow,
      // The group wrapper carries the elevation, so it has to drop it itself
      // once nothing inside is clickable: `disabled` is passed to the buttons,
      // never to the group. A split button keeps the shadow while any of its
      // actions is still enabled, since the shadow is shared.
      [`&:not(:has(> .${buttonGroupClasses.grouped}:not(.Mui-disabled)))`]: {
        boxShadow: 'none',
      },
    },
    groupedContainedPrimary: ({ theme }) => ({
      border: `1px solid ${
        ColorUtils.GetColorDarknessShades(theme.palette.primary.main).dark
      }`,
    }),
    groupedHorizontal: {
      '&:not(:last-child)': {
        marginRight: 1,
      },
      '&:not(:first-child)': {
        borderLeft: 'none',
      },
    },
    groupedContainedHorizontal: {
      '&:not(:last-child)': {
        borderRight: 'none',
      },
    },
  },
};

export default MuiButtonGroup;
